export default "__VITE_ASSET__H19KnLYq__"